const setupWinsotyMedia = (root = document) => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  root.querySelectorAll('[data-winsoty-autoplay] video').forEach((video) => {
    if (reduceMotion) {
      video.removeAttribute('autoplay');
      video.pause();
      video.controls = true;
      return;
    }

    video.play().catch(() => {
      video.controls = true;
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setupWinsotyMedia());
} else {
  setupWinsotyMedia();
}

document.addEventListener('shopify:section:load', (event) => setupWinsotyMedia(event.target));
